import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <main className="page page__pad">
      <h1 className="t-display">No encontrado</h1>
      <p className="t-lead empty__text">Esta página no existe o no tienes acceso.</p>
      <Link to="/" className="btn-link">
        Volver al inicio
      </Link>
    </main>
  );
}
